import { render, staticRenderFns } from "./Tip5.vue?vue&type=template&id=6b963eef&scoped=true&lang=pug"
import script from "./Tip5.vue?vue&type=script&lang=ts"
export * from "./Tip5.vue?vue&type=script&lang=ts"
import style0 from "./Tip5.vue?vue&type=style&index=0&id=6b963eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b963eef",
  null
  
)

export default component.exports